import { useTranslation } from "react-i18next";

export function InsurerEmailBlockNotice(props: {
  reason?: "complained" | "unsubscribed" | null;
  feedback?: string | null;
}) {
  const { t } = useTranslation();
  const key =
    props.reason ??
    (["bounced", "failed"].includes(props.feedback ?? "") ? "delivery_failed" : null);
  if (!key) return null;
  return (
    <p
      role="status"
      className="order-last mt-2 basis-full rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-800"
    >
      {t(`insurer_email_block.${key}`)}
    </p>
  );
}
